import { QuestionCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Alert, message, Empty, Tooltip } from "antd";
import { useState } from "react";
import { CarComponent, PageLoading } from "..";
const Index = (props) => {
  const [data, setData] = useState(null);
  const [number, setNumber] = useState("");
  const [loading, setLoading] = useState(false);

  const onChangePlate = (e) => {
    let value = e?.target?.value.toUpperCase().replace(/[^0-9А-ЯӨөҮүЁё]/g, "");
    const numbersPart = value.slice(0, 4).replace(/[^0-9]/g, "");
    const lettersPart = value.slice(4).replace(/[^А-ЯӨөҮүЁё]/g, "");
    const formattedValue = (numbersPart + lettersPart).slice(0, 7);

    setNumber(formattedValue);
  };

  const handleVerify = () => {
    if (number?.length === 7) {
      setLoading(true);
      props
        ?.request({
          url: "",
          method: "POST",
          mode: "car",
          body: {
            serviceCode: "WS100401_getVehicleInfo",
            customFields: {
              plateNumber: number,
            },
          },
        })
        ?.then((res) => {
          setLoading(false);
          if (res) setData(res);
          else setData(null);
        });
    } else message.error("Дугаараа 1234УБА хэлбэрээр бүрэн оруулна уу.");
  };

  const handleNext = () => {
    if (data) {
      props?.setCollect({ ...props?.collect, info: data });
      props?.setStep(props?.step + 1);
    } else {
      message.error("Машины мэдээлэл татагдаагүй байна.");
    }
  };

  return (
    <div className="w-full flex flex-col items-center">
      <div className="flex flex-col gap-3 w-full">
        <span className="font-bold">Тээврийн хэрэгсэлийн мэдээлэл</span>
        <Alert
          type="info"
          message="Машины дугаараа оруулж баталгаажуулснаар үргэлжлүүлэх боломжтой."
          showIcon
        />
      </div>
      <div className="flex flex-col gap-1 mt-4 lg:mt-8 w-full lg:w-2/6">
        <div className="flex gap-2 justify-center w-full">
          <Input
            placeholder="1234УБА"
            className="w-44"
            onChange={onChangePlate}
            value={number}
            maxLength={7}
            suffix={
              <Tooltip title="4 тоо, ард нь 3 кирилл үсэг. Жишээ: 1234УБА">
                <QuestionCircleOutlined className="text-gray-400" />
              </Tooltip>
            }
          />
          <Button
            icon={<SearchOutlined />}
            type="primary"
            loading={props?.iscarinfo === true}
            onClick={handleVerify}
          >
            Шалгах
          </Button>
        </div>
        <span className="text-xs text-gray-500">
          Формат: 4 тоо + 3 кирилл үсэг (жишээ нь: 1234УБА)
        </span>
      </div>
      {loading === true ? <PageLoading /> : null}
      {loading === false && !data?.plateNumber ? (
        <div className="mt-10 flex flex-col items-center">
          <Empty imageStyle={{ height: 50 }} />
          <Button
            className="w-fit mt-4 lg:mt-8"
            onClick={() => props?.setStep(props?.step - 1)}
          >
            Буцах
          </Button>
        </div>
      ) : null}
      {data?.plateNumber ? (
        <CarComponent
          data={data}
          handleNext={handleNext}
          setStep={props?.setStep}
          step={props?.step}
        />
      ) : null}
    </div>
  );
};

export default Index;
